import { render, staticRenderFns } from "./PreviewRecipientList.vue?vue&type=template&id=c9f95104"
import script from "./PreviewRecipientList.vue?vue&type=script&lang=js"
export * from "./PreviewRecipientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports